(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/best-bet-rows/assets/javascripts/single-rows-presentation.js') >= 0) return;  svs.modules.push('/components/tipsen/best-bet-rows/assets/javascripts/single-rows-presentation.js');
"use strict";


const SingleRowsPresentation = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement("div", {
    className: ['pg_best_bet_rows'].concat(className || []).join(' ')
  }, children);
};
setGlobal('svs.tipsen.components.bestBetRows.SingleRowsPresentation', SingleRowsPresentation);

 })(window);